export async function signMessageToBase64(
  signMessage: ((message: Uint8Array) => Promise<Uint8Array>) | undefined,
  message: string,
): Promise<string | null> {
  if (!signMessage) return null;
  const msg = await signMessage(new TextEncoder().encode(message));
  const b64Message = Buffer.from(msg).toString("base64");
  return b64Message;
}
